export default "__VITE_ASSET__BPP0ycNg__"